import { FormattedNumber } from 'react-intl';

import type { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { PillButton } from '@sorare/core/src/atoms/buttons/PillButton';
import { Shards } from '@sorare/core/src/atoms/icons/Shards';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { ANY_SPORT_ESSENCE_TYPE } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import {
  playableBlockchainRarities,
  scarcityNames,
} from '@sorare/core/src/lib/cards';
import { getRarityColor, getRarityRGBColor } from '@sorare/core/src/lib/colors';

type Props = {
  rarity: Rarity;
  cardShardsCount: number;
};

export const EssenceRarityPills = ({
  rarity: selectedRarity,
  cardShardsCount,
}: Props) => {
  const { generateSportContextPath } = useSportContext();

  return (
    <Horizontal gap={1} center>
      {playableBlockchainRarities.map(rarity => {
        const selected = rarity === selectedRarity;

        return (
          <PillButton
            key={rarity}
            size="medium"
            brand
            selected={selected}
            accentRgb={getRarityRGBColor(rarity)}
            aria-label={scarcityNames[rarity]}
            startIcon={<Shards color={getRarityColor(rarity)} size={2.5} />}
            to={generateSportContextPath(ANY_SPORT_ESSENCE_TYPE, {
              params: { type: rarity },
            })}
          >
            {selected ? (
              <FormattedNumber value={cardShardsCount} useGrouping />
            ) : null}
          </PillButton>
        );
      })}
    </Horizontal>
  );
};
